import { message, Modal } from 'antd';
import React from 'react'
import { DeleteOutlined } from '@ant-design/icons';
import { useFeiyongDelMutation } from '../../store/NeiZhangFeiYongApi';
function ExpenseDel(props) {
    const {confirm} = Modal; 
    const [submitDel] = useFeiyongDelMutation()  
    return (
        <a 
            onClick={() => {
                confirm({
                        title: '删除费用',
                        content: '删除后不能恢复！',
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                 fy_id:props.fy_id,
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.info('删除成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        },
                        onCancel() {
                            // console.log('Cancel');
                        },
                    }); 
            }}
        ><DeleteOutlined /> 删除</a>
    )
}

export default ExpenseDel